module.exports = __webpack_public_path__ + "static/media/logo-title.e1d70094.png";